import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import random from 'lodash/random';
import { isReviewCompanyExportRoute, removeStaleCardExportIframes } from '~/functions/review-export';
import { useGetAccountQuery, useGetUserQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'default',
  setup: function setup(__props) {
    var route = useRoute();
    var _useNuxtApp = useNuxtApp(),
      $sentry = _useNuxtApp.$sentry,
      $i18n = _useNuxtApp.$i18n,
      $auth = _useNuxtApp.$auth;

    // Accounts whose data moved to a licensee's own instance (Account.movedToUrls).
    // A customer with any moved workspace has moved as a whole: they only get a notice
    // pointing to the new address (the API refuses everything else). IX admins keep
    // full access, with a banner on a moved workspace.
    var _useGetAccountQuery = useGetAccountQuery({}, computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      accountResult = _useGetAccountQuery.result;
    var _useGetUserQuery = useGetUserQuery(computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      userResult = _useGetUserQuery.result;
    var movedToUrls = computed(function () {
      var _accountResult$value;
      return ((_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount.movedToUrls) || [];
    });
    var isMovedForCustomer = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser.isAdmin) === false && userResult.value.getUser.accounts.some(function (account) {
        return account.movedToUrls.length > 0;
      });
    });
    var noNavPaths = ['/register/'];
    var showAppNav = computed(function () {
      return !noNavPaths.includes(route.path) && !isReviewCompanyExportRoute(route.path);
    });
    if (isVue3) {
      var _useApollo = useApollo(),
        onLogin = _useApollo.onLogin;
      onLogin();
    }
    $sentry === null || $sentry === void 0 ? void 0 : $sentry.setTag('DOMAIN', process.env.DOMAIN);
    var errors = ref([]);
    var handleMsg = function handleMsg(err, timeout) {
      var id = random(1000000, 9999999);
      var color = err.color || 'red';
      errors.value.push(_objectSpread(_objectSpread({
        id: id
      }, err), {}, {
        color: color,
        timeout: timeout
      }));
      if (timeout > 0) {
        setTimeout(function () {
          removeError(id);
        }, timeout);
      }
    };
    var removeError = function removeError(id) {
      errors.value = errors.value.filter(function (e) {
        return e.id !== id;
      });
    };
    onMounted(function () {
      removeStaleCardExportIframes();
      window.$nuxt.$on('userError', function (err) {
        handleMsg({
          color: (err === null || err === void 0 ? void 0 : err.color) || 'red',
          message: (err === null || err === void 0 ? void 0 : err.message) || String($i18n.t('defaultErrMsg'))
        }, 5000);
      });
      window.$nuxt.$on('userMsg', function (err) {
        handleMsg({
          color: (err === null || err === void 0 ? void 0 : err.color) || 'green',
          message: (err === null || err === void 0 ? void 0 : err.message) || String($i18n.t('defaultSuccessMsg'))
        }, 2000);
      });
    });
    onUnmounted(function () {
      window.$nuxt.$off('userError');
      window.$nuxt.$off('userMsg');
    });
    return {
      __sfc: true,
      route: route,
      $sentry: $sentry,
      $i18n: $i18n,
      $auth: $auth,
      accountResult: accountResult,
      userResult: userResult,
      movedToUrls: movedToUrls,
      isMovedForCustomer: isMovedForCustomer,
      noNavPaths: noNavPaths,
      showAppNav: showAppNav,
      errors: errors,
      handleMsg: handleMsg,
      removeError: removeError
    };
  }
});